import React from 'react'
import { Screen } from '../lib/screen'
import { ViewProps } from '../lib/view'

export const FallbackBackground: React.FC<ViewProps> = props => {
  return <Screen {...props} />
}
